






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { StaffPolicyList } from '@/common/Policy';
import { AxiosResponse } from 'axios';
import uuid from 'uuid/v4';
import jQuery from 'jquery';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import SelectField from '@/components/Form/SelectField.vue';
import AddPolicy from '@/components/Modal/StaffPoliciesAddPolicy.vue';

import Staff from '@/services/Staff';
import Brand from '@/services/Brand';

@Component({
	components: {
		Welcome,
		Alert,
		Loading,
		SelectField,
		AddPolicy,
	},
})
export default class ManagePoliciesList extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private policies: StaffPolicyList[] = [];
	private paginate: any = ['setupPolicies'];
	private search: string = '';
	private brandFilter: string = 'all';
	private Brand: typeof Brand = Brand;
	private selectedPolices: string[] = [];
	private refreshSuccess = false;
	private refreshError = false;
	private allSelected = false;
	private addPolicyModalID: string = uuid();
	private generateUUID: any = uuid();
	private addPolicySuccess: boolean = false;
	private addPolicyError: boolean = false;

	@Watch('allSelected')
	private watchAllSelected() {
		if (!this.allSelected) {
			this.selectedPolices = [];
			return;
		}

		this.paginate.setupPolicies.list.map(
			p =>
				!this.selectedPolices.includes(p.product_id) &&
				this.selectedPolices.push(p.product_id),
		);
	}

	get setupPolicies() {
		let policies = this.policies;

		if (this.brandFilter !== 'all') {
			policies = policies.filter(
				p => p.brand !== undefined && p.brand === this.brandFilter,
			);
		}

		if (this.search !== '') {
			const regex = new RegExp(this.search, 'g');
			policies = policies.filter(
				p => p.policy_number !== undefined && ( p.policy_number.match(regex) || p.risk_name.match(regex ) ),
			);
		}

		return policies;
	}

	private getPolicy(productId) {
		this.$router.push({
			name: 'staffpolicy',
			params: {
				product_id: productId,
			},
		});
	}

	private refreshPolicies() {
		this.refreshError = false;
		this.refreshSuccess = false;

		Staff.updatePolicy({
			cmd: 'refreshPolicies',
			product_ids: this.selectedPolices,
		})
			.then(({ data }: AxiosResponse) => (this.refreshSuccess = true))
			.catch(() => (this.refreshError = true));
	}

	private addPolicy(policyNumber, brand) {
		this.loading = true;
		this.addPolicyError = false;
		this.addPolicySuccess = false;

		if (policyNumber === '' || brand === '') {
			this.addPolicyError = false;
			jQuery('#AddPolicy').modal('hide');
		}

		Staff.updatePolicy({
			cmd: 'addPolicy',
			policy_number: policyNumber,
			brand,
		})
			.then(({ data }: AxiosResponse) => {
				jQuery('#AddPolicy').modal('hide');
				this.getPolicy(data.product_id);
			})
			.catch(() => (this.addPolicyError = true))
			.finally(() => {
				jQuery('#AddPolicy').modal('hide');
				this.loading = false;
			});
	}

	private created() {
		Staff.getPolicies()
			.then(({ data }: AxiosResponse) => {
				this.policies = data.sort((a, b) => a.policy_number > b.policy_number);
			})
			.catch(e => {
				console.log(e);
				this.error = true;
			})
			.finally(() => {
				this.loading = false;
			});
	}
}
